import React from 'react'
import { PrimaryContainer } from '../mui/PrimaryContainer'
import AddTripTab from '../tabs/AddTripTab/AddTripTab'

const AddTrip = () => {
  return (
    <PrimaryContainer>
      <AddTripTab />
    </PrimaryContainer>
  )
}

export default AddTrip